type NaturalImageDimensionsCssPx = {
  width: number;
  height: number;
};

export default async function readImageFileDimensionsCssPxFromFile(
  file: File,
): Promise<NaturalImageDimensionsCssPx | null> {
  if (typeof createImageBitmap === 'function') {
    try {
      return await readWithCreateImageBitmap(file);
    } catch {
      return await readWithImageElement(file);
    }
  }
  return await readWithImageElement(file);
}

function readWithImageElement(file: File) {
  return new Promise<NaturalImageDimensionsCssPx | null>((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    const finish = (dimensions: NaturalImageDimensionsCssPx | null) => {
      URL.revokeObjectURL(objectUrl);
      resolve(dimensions);
    };

    image.onload = () => {
      if (image.naturalWidth > 0 && image.naturalHeight > 0) {
        finish({
          width: image.naturalWidth,
          height: image.naturalHeight,
        });
        return;
      }
      finish(null);
    };
    image.onerror = () => {
      finish(null);
    };
    image.src = objectUrl;
  });
}

async function readWithCreateImageBitmap(file: File) {
  const bitmap = await createImageBitmap(file);
  try {
    if (bitmap.width <= 0 || bitmap.height <= 0) {
      return null;
    }
    return {
      width: bitmap.width,
      height: bitmap.height,
    };
  } finally {
    bitmap.close();
  }
}
